// extracted by mini-css-extract-plugin
module.exports = {"loaderElement":"loader_loaderElement__2OyoS"};